@if (multipleSelect) {
  <input [checked]="isSelected" type="checkbox" />
}
<div class="option-content">
  <ng-content></ng-content>
</div>
